import { Check, CheckCheck, Clock, XCircle } from "lucide-react";

const fmtTs = (ts) => {
  if (!ts) return "";
  const d = /^\d+$/.test(String(ts)) ? new Date(Number(ts) * 1000) : new Date(ts);
  return isNaN(d) ? "" : d.toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
};

export const waState = (l) => {
  if (l.status === "failed" || l.wa_status === "failed") return { key: "failed", label: "Falhou", Icon: XCircle, cls: "text-red-400 border-red-500/40 bg-red-500/10", at: l.failed_at };
  if (l.wa_status === "read") return { key: "read", label: "Lido", Icon: CheckCheck, cls: "text-sky-300 border-sky-500/40 bg-sky-500/10", at: l.read_at };
  if (l.wa_status === "delivered" || l.status === "delivered") return { key: "delivered", label: "Entregue", Icon: CheckCheck, cls: "text-emerald-300 border-emerald-500/40 bg-emerald-500/10", at: l.delivered_at };
  if (l.status === "sent") return { key: "sent", label: "Enviado", Icon: Check, cls: "text-slate-300 border-slate-500/40 bg-slate-500/10", at: l.sent_at };
  return { key: l.status, label: l.status === "mock" ? "Simulado" : "Ignorado", Icon: Clock, cls: "text-amber-300 border-amber-500/40 bg-amber-500/10", at: l.sent_at };
};

export const WaStatusPill = ({ log, testid }) => {
  const s = waState(log);
  return (
    <span data-testid={testid} data-status={s.key}
      className={`inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-[11px] font-semibold ${s.cls}`}>
      <s.Icon className="h-3.5 w-3.5" /> {s.label}{s.at ? ` · ${fmtTs(s.at)}` : ""}
      {s.key === "failed" && (log.wa_reason || log.error) && <span data-testid={`${testid}-reason`} title={log.wa_reason || log.error} className="max-w-[220px] truncate font-normal text-red-300/80">· {log.wa_reason || String(log.error).replace(/^WhatsApp:?\s*/, "")}</span>}
    </span>
  );
};

export const LastWaCharge = ({ items }) => {
  const last = (items || []).find((l) => l.channel === "whatsapp" && l.status !== "skipped");
  return (
    <div data-testid="last-wa-charge" className="mt-1.5 flex flex-wrap items-center gap-2 text-xs text-slate-400">
      <span>Cobrança WhatsApp:</span>
      {last ? <WaStatusPill log={last} testid="last-wa-charge-status" /> : <span data-testid="last-wa-charge-status" data-status="none" className="text-slate-500">nenhuma enviada</span>}
    </div>
  );
};
